import React from "react";
import { ReactNode } from "react";
import Footer from "@/components/Footer/Footer";

interface MainContentProps {
  children: ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <div className="relative h-full flex flex-col overflow-hidden bg-gray-50 dark:bg-slate-950">
      <main className="relative flex-1 overflow-y-auto" id="main-scroll-area">
        <div>{children}</div>
      </main>
      <Footer />
    </div>
  );
};

export default MainContent;
